export default `
  mutation claimCampaignOffer {
    claimCampaignOffer {
      success
      status
      message
      campaignId
      trialDays
      subscriptionId
    }
  }
`
